// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__3IJPI","label":"Checkbox_label__RSwO4","checkbox":"Checkbox_checkbox__3PR-Y","icon":"Checkbox_icon__2Dj5W","input":"Checkbox_input__3BB9I"};